/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Abbreviated team info for tournament detail view
 * @export
 * @interface TournamentTeamSummary
 */
export interface TournamentTeamSummary {
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    tag?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentTeamSummary
     */
    seed?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentTeamSummary
     */
    rosterCount: number;
    /**
     * User ID of the team captain, used by the player UI to gate score submission
     * @type {string}
     * @memberof TournamentTeamSummary
     */
    captainId?: string;
}

/**
 * Check if a given object implements the TournamentTeamSummary interface.
 */
export function instanceOfTournamentTeamSummary(value: object): value is TournamentTeamSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rosterCount' in value) || value['rosterCount'] === undefined) return false;
    return true;
}

export function TournamentTeamSummaryFromJSON(json: any): TournamentTeamSummary {
    return TournamentTeamSummaryFromJSONTyped(json, false);
}

export function TournamentTeamSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentTeamSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'tag': json['tag'] == null ? undefined : json['tag'],
        'seed': json['seed'] == null ? undefined : json['seed'],
        'rosterCount': json['rosterCount'],
        'captainId': json['captainId'] == null ? undefined : json['captainId'],
    };
}

export function TournamentTeamSummaryToJSON(json: any): TournamentTeamSummary {
    return TournamentTeamSummaryToJSONTyped(json, false);
}

export function TournamentTeamSummaryToJSONTyped(value?: TournamentTeamSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'tag': value['tag'],
        'seed': value['seed'],
        'rosterCount': value['rosterCount'],
        'captainId': value['captainId'],
    };
}

